import { action, makeObservable, observable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export type AggregationParameter = 'paid' | 'incurred';
export class QuaterlyReportStore {
  tableData: any[] = [];
  incurredStartDate: string = '';
  incurredEndDate: string = '';
  paidStartDate: string = '';
  paidEndDate: string = '';
  maxIncurred: string = '';
  minIncurred: string = '';
  maxPaid: string = '';
  minPaid: string = '';
  aggregationParameter: AggregationParameter = 'paid';
  isIncurredDate: boolean = true;
  isPaidDate: boolean = true;
  isPlanDatesFetched: boolean = false;
  planDates: any[] = [];
  selectedPlanIndex: number = -1;
  noDateFilter: boolean = false;

  constructor() {
    makeObservable(this, {
      tableData: observable,
      incurredStartDate: observable,
      incurredEndDate: observable,
      paidStartDate: observable,
      paidEndDate: observable,
      maxIncurred: observable,
      minIncurred: observable,
      maxPaid: observable,
      minPaid: observable,
      aggregationParameter: observable,
      isIncurredDate: observable,
      isPaidDate: observable,
      isPlanDatesFetched: observable,
      planDates: observable,
      selectedPlanIndex: observable,
      noDateFilter: observable,
      removeTableData: action,
      setTableData: action,
      setIncurredStartDate: action,
      setIncurredEndDate: action,
      setPaidStartDate: action,
      setPaidEndDate: action,
      setAggregationParameter: action,
      setIsPlanDatesFetched: action,
      removeDates: action,
      setPlanDates: action,
      setNoDateFilter: action,
    });
    makePersistable(this, {
      name: 'QuaterlyReportStore',
      properties: [
        'tableData',
        'incurredStartDate',
        'incurredEndDate',
        'paidStartDate',
        'paidEndDate',
        'maxIncurred',
        'minIncurred',
        'maxPaid',
        'minPaid',
        'aggregationParameter',
        'isIncurredDate',
        'isPaidDate',
        'isPlanDatesFetched',
        'planDates',
        'selectedPlanIndex',
        'noDateFilter',
      ],
      storage: window.localStorage,
    });
  }

  removeTableData() {
    this.tableData = [];
  }
  setTableData(tableData: any[]) {
    this.tableData = tableData;
  }
  setIncurredStartDate(startDate: string) {
    this.incurredStartDate = startDate;
  }
  setIncurredEndDate(endDate: string) {
    this.incurredEndDate = endDate;
  }
  setPaidStartDate(startDate: string) {
    this.paidStartDate = startDate;
  }
  setPaidEndDate(endDate: string) {
    this.paidEndDate = endDate;
  }
  setMinMaxDates(
    minIncurred: string,
    maxIncurred: string,
    minPaid: string,
    maxPaid: string,
  ) {
    this.minIncurred = minIncurred;
    this.maxIncurred = maxIncurred;
    this.minPaid = minPaid;
    this.maxPaid = maxPaid;
  }
  setAggregationParameter(aggregationParameter: AggregationParameter) {
    this.aggregationParameter = aggregationParameter;
  }
  setIsIncurredDate(isIncurredDate: boolean) {
    this.isIncurredDate = isIncurredDate;
  }
  setIsPaidDate(isPaidDate: boolean) {
    this.isPaidDate = isPaidDate;
  }
  setIsPlanDatesFetched(isPlanDatesFetched: boolean) {
    this.isPlanDatesFetched = isPlanDatesFetched;
  }
  setPlanDates(planDates: any[]) {
    this.planDates = planDates;
  }
  setSelectedPlanIndex(selectedPlanIndex: number) {
    this.selectedPlanIndex = selectedPlanIndex;
  }
  setNoDateFilter(noDateFilter: boolean) {
    this.noDateFilter = noDateFilter;
  }
  removeDates() {
    this.incurredStartDate = '';
    this.incurredEndDate = '';
    this.paidStartDate = '';
    this.paidEndDate = '';
    this.aggregationParameter = 'paid';
    this.isPlanDatesFetched = false;
    this.planDates = [];
    this.selectedPlanIndex = -1;
    this.maxIncurred = '';
    this.minIncurred = '';
    this.maxPaid = '';
    this.minPaid = '';
    this.noDateFilter = false;
  }
}
